import React, { useContext, useState } from 'react';
import ActionLink, { ACTION_LINK_HEIGHT } from '../../../../../Footer/ActionLink';
import { SubmissionContext } from '../../Context/SubmissionProvider';
import { Box } from '@mui/material';
import SubmissionStatusHeader from '../SubmissionStatusHeader';
import SubmissionOverviewHeader from './SubmissionOverviewHeader';
import { AccordionSection } from '../../../../Admin/Game/GameTab/utils';
import Feedback from '../../../../../../../common/components/Feedback';
import DeveloperSubmissionStats from '../../DeveloperSubmissionStats/DeveloperSubmissionStats';
import SubmissionOverviewGameBuilds from './SubmissionOverviewGameBuilds';
import { NON_RELEASED_STATUSES } from '../UpdateSubmission.types';
import { updateSubmission } from '../../Mutations/update-submission-mutation';
import { submissionHadBasicLaunch } from '../../../../../../helpers/flowHelpers';
import { createIframeUpdate } from '../helpers';

type SubmissionOverviewProps = {
  goToInfoUpdate(): void;
  createNewGameBuild(): void;
};

const SubmissionOverview: React.FC<SubmissionOverviewProps> = ({ goToInfoUpdate, createNewGameBuild }) => {
  const { submission, gameBuild, baseForm, detailsForm, isNonEditable } = useContext(SubmissionContext);

  const [isSaving, setIsSaving] = useState(false);

  if (!submission) {
    return null;
  }

  const isReleased = !NON_RELEASED_STATUSES.includes(submission.status) || submissionHadBasicLaunch(submission.statusChanges);

  const shouldDisplayTeamFeedback = submission.feedback.length > 0 && submission.status !== 'DRAFT';

  const isIframe = gameBuild?.loaderType === 'iframe';

  const handleIframeUpdate = async () => {
    await createIframeUpdate(submission!, baseForm!, detailsForm!, setIsSaving, updateSubmission);
  };

  return (
    <Box sx={{ paddingBottom: `${ACTION_LINK_HEIGHT}px` }}>
      {/* HEADER SECTION */}
      <SubmissionOverviewHeader submission={submission} goToInfoUpdate={goToInfoUpdate} createNewGameBuild={createNewGameBuild} />
      {/* NOTIFICATION SECTION */}
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <SubmissionStatusHeader />
      </Box>

      {/* CONTENT SECTION */}
      {isReleased && <DeveloperSubmissionStats submission={submission} />}
      <AccordionSection title="Version history" defaultExpanded>
        <SubmissionOverviewGameBuilds submission={submission} />
      </AccordionSection>
      {shouldDisplayTeamFeedback && (
        <AccordionSection title="Team feedback" defaultExpanded={false}>
          <Feedback feedback={submission.feedback} />
        </AccordionSection>
      )}
      {/* @TODO (copied from previous code): Enable UserFeedback below whenever it gets implemented */}
      {/* {submission.feedback && (
        <AccordionSection title="User feedback" expanded={false}>
          <UserFeedback submission={submission} />
        </AccordionSection>
      )} */}
      {/* FOOTER SECTION */}
      <ActionLink
        primaryButton={
          isNonEditable
            ? undefined
            : {
                title: 'Submit new version',
                callback: () => createNewGameBuild(),
              }
        }
        middleButton={
          isIframe && !isNonEditable
            ? {
                title: 'Go to QA and notify admins of changes',
                callback: () => handleIframeUpdate(),
                isLoading: isSaving,
                tooltip: 'If you updated your iframe, you need to go to QA and notify the admins of the change.',
                color: 'white',
              }
            : undefined
        }
      />
    </Box>
  );
};

export default SubmissionOverview;
